export const checkIfWebView = () => {
	if (typeof window == 'undefined') {
		return;
	}
	const userAgent = window.navigator?.userAgent?.toLowerCase();

	const possibleStrings = [
		'instagram',
		'fbav', // Facebook
		'fban', // Facebook
		'twitter',
		'bytedance', // TikTok
		'bytelo' // TikTok
	];
	return possibleStrings.some(str => userAgent.includes(str));
};